import type { FollowInvite } from "@tandemdiabetes/sugarmate-api-react-client"
import { useRemoveFollowInvite } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollowInvites } from "./useFollowInvites"
import { noticeError } from "src/utils"

export function useDeleteFollowInvite() {
  const removeFollowInvite = useRemoveFollowInvite()
  const {
    mutate,
    data: followInvites,
  } = useFollowInvites()

  return useMemo(
    () => removeFollowInvite && (async (id: FollowInvite["id"]) => {
      try {
        const response = await removeFollowInvite(id)

        if (followInvites) {
          const updatedList = followInvites.filter((cachedFollowInvite) => cachedFollowInvite.id !== id)

          void mutate(updatedList)
        } else {
          void mutate()
        }

        return response
      } catch (e) {
        noticeError(
          e,
          "DeleteFollowInvite",
          { id },
        )

        throw e
      }
    }),
    [
      removeFollowInvite,
      followInvites,
      mutate,
    ],
  )
}
